import React, { Component, useRef } from "react";
import Delete from '../../../../../Assets/img/svg/delete.svg';
import del from "../../../../../Assets/img/svg/Del.svg"
import View from "../../../../../Assets/img/svg/view.svg"
import {TextField} from "@material-ui/core";
import successIcon from "../../../../../Assets/img/svg/Check.svg"
import errorIcon from "../../../../../Assets/img/svg/cancelerror.svg"
import List from '@material-ui/core/List';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import $ from "jquery";
import withRouter from "../../../../custom/withRouter";
import { connect } from "react-redux";
import styles from "../../../../../Assets/jss/customStyle";
import { withStyles } from '@material-ui/core/styles';
import moment from "moment"
import axios from "axios";
import API from "../../../../../helpers/endpointService"
import { CssTextField } from "../../../../custom/textField"
import { inspectionSystem } from "../../../../Constants";
import {warningAlert,successAlert} from "../../../../custom/alert"
import { errorToast } from "../../../../../actions/CommonFunction";

class AddEditCondition extends Component {
  constructor(props) {
    super(props);
    this.inputFile = React.createRef();
    this.state = {
      successId: 0,
      isSuccess: false,
      isFailure: false,
      isSuccessComment: false,
      isFailureComment: false,
      CommentId: "",
      ShipId: 0,
      UserRole: "",
      isMobile: false,
      isView: false,
      DocsName: [],
      total1: 0,
      total2: 0,
      total3: 0,
      total4: 0,
      total5: 0,
      totalteu1: 0,
      InspectionId: 0,
      Hatch: [],
      CargoHold: [],
      ReeferCapacity: [],
      HatchComments:"",
      CargoHoldComments:"",
      ReeferCapacityComments:""
    }
  }

  componentDidMount() {
    const { dispatch } = this.props;
    this.state.ShipId = localStorage.getItem("DashId");
    this.state.UserRole = localStorage.getItem("UserRoles");
    this.state.InspectionId = parseInt(localStorage.getItem("InspectionId"));
    this.setState({})
    this.HatchTable();
    this.CargoHoldTable();
    this.ReeferTable();
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.interval = setInterval(() => {
        this.resize1()
    }, 10);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
    $("#TRAIN1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#Cargocon1 .MuiListItemText-primary").removeClass("fw-bolder");
    $("#Cargocon").addClass("d-none");
    $("#Cargocon").removeClass("d-block");
    $("#TML").removeClass("active-color");
    $("#TMT").removeClass("fw-bolder");
  }
  resize = () => {
    if (window.innerWidth < 850) {
      this.setState({
        isMobile: true
      })
    }
    else {
      this.setState({
        isMobile: false
      })
    }
  };

  resize1 = () => {
    $("#TRAIN1 .MuiListItemText-primary").addClass("spanTopBar");
    $("#Cargocon1 .MuiListItemText-primary").addClass("fw-bolder");
    $("#Cargocon").removeClass("d-none");
    $("#Cargocon").addClass("d-block");
    $("#TML").addClass("active-color");
    $("#TMT").addClass("fw-bolder");
  }

  sidebar = () => {
    this.props.navigate("/sidebar");
  }
  OpenPopup = () => {
    window.$("#deletepopup").modal("show")
  }
  HatchTable = () => {
    let apiUrl = `${API.Get_Checklist}?sectionId=${inspectionSystem.CargoCondition}&inspectionId=${this.state.InspectionId}`;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.setState({
            Hatch: response?.data,
          },()=>{
            this.GetHatchComments();
          });
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (error?.response?.status === 401) {
        }
      });
  };
  CargoHoldTable = () => {
    let apiUrl = `${API.Get_Checklist}?sectionId=${inspectionSystem.CargoHoldCapacities}&inspectionId=${this.state.InspectionId}`;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.setState({
            CargoHold: response?.data,
          },()=>{
            this.GetCargoHoldComments();
          });
          this.state.CargoHold && this.state.CargoHold?.Questions.map((i) => (
            i.AnswersList?.sort((a, b) => {
              return a.CategoryId - b.CategoryId;
            }),
            i.AnswersList?.map((c) => (
              c.AnswerLookupList?.sort((s, a) => {
                return s.Id - a.Id;
              })
            )),
            i.AnswersList1?.sort((a, b) => {
              return a.CategoryId - b.CategoryId;
            }),
            i.AnswersList1?.map((c) => (
              c.AnswerLookupList?.sort((s, a) => {
                return s.Id - a.Id;
              })
            ))
          ))
          this.setState({})
          this.state.total1 = 0;
          this.state.total2 = 0;
          this.state.total3 = 0;
          this.state.total4 = 0;
          let count = 0;
          let count1 = 0;
          this.state.CargoHold && this.state.CargoHold?.Questions?.map((i, ind) => (
            i.AnswersList1?.map((a) => ((a?.AnswerLookupList[0]?.Answer != "" && a?.AnswerLookupList[0]?.Answer) ?
              (count += parseInt(a?.AnswerLookupList[0]?.Answer.split(" ")[0]),
                count1 += parseInt(a?.AnswerLookupList[0]?.Answer.split(" ")[0])) : 0
            )),
            document.getElementById("totalteu" + ind).innerText = count + " TEU",
            count = 0,
            i.AnswersList1?.map((a) => ((a?.AnswerLookupList[0]?.Answer != "" && a?.AnswerLookupList[0]?.Answer) ?
              a.CategoryName === "M^3" ? this.state.total1 += parseInt(a?.AnswerLookupList[0]?.Answer) :
                a.CategoryName === "TEU in holds" ? this.state.total2 += parseInt(a?.AnswerLookupList[0]?.Answer.split(" ")[0]) :
                  a.CategoryName === "TEU on deck" ? this.state.total3 += parseInt(a?.AnswerLookupList[0]?.Answer.split(" ")[0]) :
                    a.CategoryName === "Total TEUe" ? this.state.total4 += parseInt(a?.AnswerLookupList[0]?.Answer.split(" ")[0]) : 0 : 0
            )),
            this.state.total4 = count1
          ))
          this.setState({})
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        if (error?.response?.status === 401) {
        }
      });
  };
  ReeferTable = () => {
    let apiUrl = `${API.Get_Checklist}?sectionId=${inspectionSystem.Reefercapacity}&inspectionId=${this.state.InspectionId}`;
    this.props.dispatch({ type: "SHOW_LOADER", data: true });
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.setState({
            ReeferCapacity: response?.data,
          },()=>{
            this.GetCapacityComments();
          });
          this.state.total5 = 0;
          this.state.ReeferCapacity && this.state.ReeferCapacity?.Questions?.map((i, ind) => (
            i.QuestionDescription !== "TOTAL" ? (i?.Answer !== "" && i.Answer > 0) ? this.state.total5 += parseInt(i?.Answer) : 0 : 0
          ))
          this.setState({})
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        } else {
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
         // warningAlert("Something went wrong. Please try again.");
         errorToast();
         this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
  };

 /* Checklist comments code */
 handleInputCommentChange = (e, field) => {
  if(field==="Hatch"){
    this.state.HatchComments=e.target.value;
  }else if(field==="CargoHold"){
    this.state.CargoHoldComments=e.target.value;
  }else if(field==="ReeferCapacity"){
    this.state.ReeferCapacityComments=e.target.value;
  }
  this.state.CommentId=field;
  this.setState({})
}
updateOperationalComments = (e, field) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  let shipId=parseInt(this.state.ShipId)
  let data={
    shipId:shipId,
    sectionId: 0,
     comments: "",
     modifiedBy:currentUser.email
    }
     if(field==="Hatch"){
      data.sectionId=inspectionSystem.CargoCondition;
      data.comments=this.state.HatchComments;
    }else if(field==="CargoHold"){
      data.sectionId=inspectionSystem.CargoHoldCapacities;
      data.comments=this.state.CargoHoldComments; 
    }else if(field==="ReeferCapacity"){
      data.sectionId=inspectionSystem.Reefercapacity;
      data.comments=this.state.ReeferCapacityComments;
    }
  this.UpdateChecklistComments(data)
}
 UpdateChecklistComments = (data) => {
let apiUrl = `${API.AddEdit_checklist_comments}`;
this.props.dispatch({ type: "SHOW_LOADER", data: true })
axios({
  method: "PUT",
  url: apiUrl,
  data: data,
})
  .then((response) => {
    if (response?.status === 200) {
      this.GetHatchComments();
      this.GetCargoHoldComments();
      this.GetCapacityComments();
      this.props.dispatch({ type: "SHOW_LOADER", data: false })
      this.setState({ isSuccessComment: true })
      setTimeout(() => {
        this.setState({ isSuccessComment: false, CommentId: 0, })
      }, 3000);
    } else {
      this.setState({ isFailureComment: true })
      setTimeout(() => {
        this.setState({ isFailureComment: false, CommentId: 0 })
      }, 3000);
    }
  })
  .catch((error) => {
    this.props.dispatch({ type: "SHOW_LOADER", data: false })
    this.setState({ isFailureComment: true })
    setTimeout(() => {
      this.setState({ isFailureComment: false, CommentId: 0 })
    }, 3000);
    if (error?.response?.status === 401) {
    }
  });
}

GetHatchComments=()=>{
  let apiUrl = `${API.Get_Checklist_comments}?shipId=${this.state.ShipId}&sectionId=${inspectionSystem.CargoCondition}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.state.HatchComments=response.data.comments;
          this.setState({});
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        } 
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        // warningAlert("Something went wrong. Please try again.");
        errorToast();
        this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
}

GetCargoHoldComments=()=>{
  let apiUrl = `${API.Get_Checklist_comments}?shipId=${this.state.ShipId}&sectionId=${inspectionSystem.CargoHoldCapacities}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.state.CargoHoldComments=response.data.comments;
          this.setState({});
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        } 
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
        // warningAlert("Something went wrong. Please try again.");
        errorToast();
        this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
}

GetCapacityComments=()=>{
  let apiUrl = `${API.Get_Checklist_comments}?shipId=${this.state.ShipId}&sectionId=${inspectionSystem.Reefercapacity}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          this.state.ReeferCapacityComments=response.data.comments;
          this.setState({});
          this.props.dispatch({ type: "SHOW_LOADER", data: false });
        } 
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false });
         // warningAlert("Something went wrong. Please try again.");
         errorToast();
         this.props.dispatch({ type: "CANCEL", data: true });
        if (error?.response?.status === 401) {
        }
      });
}

  handleInputChange = (e, str) => {
    this.state.successId = str.QuestionId;
    this.state.isSuccess= false;
    this.state.isFailure= false;
    this.setState({})
    this.state.Hatch && this.state.Hatch?.Questions?.map((i, ind) => (
      i.AnswerId == str.AnswerId ? str.Answer = e.target.value : ""
    ))
    this.setState({})
  }
  handleInputChange1 = (e, str, Id, Name) => {
    this.state.successId = str.QuestionId;
    this.state.isSuccess= false;
    this.state.isFailure= false;
    this.setState({})
    this.state.CargoHold && this.state.CargoHold?.Questions?.map((i, ind) => (
      i.AnswerId == str.AnswerId ? str.Answer = e.target.value : ""
    ))
    var data = {
      Id: 0,
      CategoryId: Id,
      CategoryName: Name,
      AnswerLookupList: [{ Id: 0, "Answer": e.target.value }],
    }
    this.state.CargoHold && this.state.CargoHold?.Questions?.map((i, ind) => (
      i.QuestionId == str.QuestionId ?
        (i?.AnswersList1 === null || i?.AnswersList1.length === 0) ? i?.AnswersList1.push(data) :
          (i?.AnswersList1.length > 0) ?
            i?.AnswersList1?.map((a, indexs) => a.CategoryId === Id ? a.AnswerLookupList[0].Answer = e.target.value : i?.AnswersList1.push(data))
            : i?.AnswersList1.push(data) : ""
    ))
    this.setState({})
    this.state.CargoHold && this.state.CargoHold?.Questions.map((i) => (
      i.AnswersList?.sort((a, b) => {
        return a.CategoryId - b.CategoryId;
      }),
      i.AnswersList?.map((c) => (
        c.AnswerLookupList?.sort((s, a) => {
          return s.Id - a.Id;
        })
      )),
      i.AnswersList1?.sort((a, b) => {
        return a.CategoryId - b.CategoryId;
      }),
      i.AnswersList1?.map((c) => (
        c.AnswerLookupList?.sort((s, a) => {
          return s.Id - a.Id;
        })
      ))
    ))
    this.setState({})
    this.state.total1 = 0;
    this.state.total2 = 0;
    this.state.total3 = 0;
    this.state.total4 = 0;
    let count = 0;
    let count1 = 0;
    this.state.CargoHold && this.state.CargoHold?.Questions?.map((i, ind) => (
      i.AnswersList1?.map((a) => ((a?.AnswerLookupList[0]?.Answer != "" && a?.AnswerLookupList[0]?.Answer) ?
        (count += parseInt(a?.AnswerLookupList[0]?.Answer.split(" ")[0]),
          count1 += parseInt(a?.AnswerLookupList[0]?.Answer.split(" ")[0])) : <></>
      )),
      document.getElementById("totalteu" + ind).innerText = count + " TEU",
      count = 0,
      i.AnswersList1?.map((a) => ((a?.AnswerLookupList[0]?.Answer != "" && a?.AnswerLookupList[0]?.Answer) ?
        a.CategoryName === "M^3" ? this.state.total1 += parseInt(a?.AnswerLookupList[0]?.Answer) :
          a.CategoryName === "TEU in holds" ? this.state.total2 += parseInt(a?.AnswerLookupList[0]?.Answer.split(" ")[0]) :
            a.CategoryName === "TEU on deck" ? this.state.total3 += parseInt(a?.AnswerLookupList[0]?.Answer.split(" ")[0]) :
              a.CategoryName === "Total TEUe" ? this.state.total4 += parseInt(a?.AnswerLookupList[0]?.Answer.split(" ")[0]) : <></> : <></>
      )),
      this.state.total4 = count1
    ))
    this.setState({})
  }

  handleInputChange2 = (e, str) => {
    this.state.successId = str.QuestionId;
    this.state.isSuccess= false;
    this.state.isFailure= false;
    this.setState({})
    this.state.ReeferCapacity && this.state.ReeferCapacity?.Questions?.map((i, ind) => (
      i.AnswerId == str.AnswerId ? str.Answer = e.target.value : ""
    ))
    this.setState({})
    this.state.total5 = 0;
    this.state.ReeferCapacity && this.state.ReeferCapacity?.Questions?.map((i, ind) => (
      i.QuestionDescription !== "TOTAL" ? (i?.Answer !== "" && i.Answer > 0) ? this.state.total5 += parseInt(i?.Answer) : 0 : 0
    ))
    this.setState({})
  }

  updatemastercomments = (e, str) => {
    let data = {
      QuestionId: str.QuestionId,
      AnswerType: str.AnswerType,
      AnswerId: 0,
      InspectionId: this.state.InspectionId,
      Id: str.AnswerId === null ? 0 : str.AnswerId,
      AnswerCategory: 0,
      Answer: e.target.value.trim(),
      MultipleAnswerIds : "",
      CreatedBy: this.state.UserRole
    }
    if (data.Id === 0) {
      this.post_conditionStatus(data)
    } else {
      this.put_conditionStatus(data, data.Id)
    }

  }
  updatemastercomments1 = (e, str, Id, AnswerId) => {
    console.log(str, AnswerId)
    let data = {
      QuestionId: str.QuestionId,
      AnswerType: str.AnswerType,
      AnswerId: 0,
      InspectionId: this.state.InspectionId,
      Id: (AnswerId === null || AnswerId === undefined) ? 0 : AnswerId,
      AnswerCategory: Id,
      Answer: e.target.value.trim(),
      MultipleAnswerIds : "",
      CreatedBy: this.state.UserRole
    }
    console.log(data.Id)
    if (data.Id === 0) {
      this.post_conditionStatus(data)
    } else {
      this.put_conditionStatus(data, data.Id)
    }
  }

  post_conditionStatus = (data) => {
    let apiUrl = `${API.AddEdit_checklist}`;
    this.props.dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          this.HatchTable();
          this.CargoHoldTable();
          this.ReeferTable();
          this.setState({ isSuccess: true })
          setTimeout(() => {
            if(this.state.isSuccess===true){
              this.setState({ isSuccess: false, successId: 0, })
            }
          }, 2000);
        } else {
          this.setState({ isFailure: true })
          setTimeout(() => {
            if(this.state.isFailure===true){
              this.setState({ isFailure: false, successId: 0 })
            }
           }, 3000);
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        this.setState({ isFailure: true })
        setTimeout(() => {
          if(this.state.isFailure===true){
            this.setState({ isFailure: false, successId: 0 })
          }
         }, 3000);
        if (error?.response?.status === 401) {
        }
      });
  }
  put_conditionStatus = (data, Id) => {
    let apiUrl = `${API.AddEdit_checklist}?id=${Id}`;
    this.props.dispatch({ type: "SHOW_LOADER", data: true })
    axios({
      method: "POST",
      url: apiUrl,
      data: data,
    })
      .then((response) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        if (response?.status === 200) {
          this.HatchTable();
          this.CargoHoldTable();
          this.ReeferTable();
          this.setState({ isSuccess: true })
          setTimeout(() => {
            if(this.state.isSuccess===true){
              this.setState({ isSuccess: false, successId: 0, })
            }
          }, 2000);
        } else {
          this.setState({ isFailure: true })
          setTimeout(() => {
            if(this.state.isFailure===true){
              this.setState({ isFailure: false, successId: 0 })
            }
           }, 3000);
        }
      })
      .catch((error) => {
        this.props.dispatch({ type: "SHOW_LOADER", data: false })
        this.setState({ isFailure: true })
        setTimeout(() => {
          if(this.state.isFailure===true){
            this.setState({ isFailure: false, successId: 0 })
          }
         }, 3000);
        if (error?.response?.status === 401) {

        }
      });
  };
  AddCancel1 = () => {
    this.props.navigate(`/shiplist`)
  }
  render() {
    let { classes, menuToggle } = this.props;

    return (
      <>
        {
          this.state.isMobile ?
            <>
              <div className="row w-100 border-bottom mt-4 mob-topfixed">
                <div className="col-6 mt-auto">
                  <List className="pt-3 mt-4 pl-3" style={{ backgroundColor: "#F6F6F6" }}>
                    <ListItem onClick={this.sidebar} >
                      <ListItemText id={"TRAIN" + "1"} className='  textNaviIcon' primary="Inspection Tasks" />
                      <NavigateNextIcon id="TRAIN" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                      <Divider className='border-bottom' />
                    </ListItem>
                  </List>
                </div>
                <div className="col-6 pt-2 mt-5 ">
                  <h4>Ship Specific Condition - Container</h4>
                </div>
              </div>
            </>
            :
            <></>
        }
        <div className="ml-auto scroll-hide mt-138" style={{ backgroundColor: "#FFFFFF", width: this.state.isMobile ? "100%" : menuToggle ? "calc(100% - 240px)" : "calc(100% - 64px)", marginTop: this.state.isMobile ? '' : -75 }}>
          {this.state.isMobile ? (
            <table className="dataTable border-top" width="100%">
              <tbody>
                <tr>
                  <td className="border-right text-center">
                    <i
                      class="fa fa-arrow-left cursorPointer"
                      onClick={this.AddCancel1}
                    ></i>
                  </td>
                </tr>
              </tbody>
            </table>
          ) : (
            <>
              <table className="dataTable" width="100%">
                <tbody>
                  <tr>
                    <td width="5%" className="border-right text-center">
                      <i
                        class="fa fa-arrow-left cursorPointer"
                        onClick={this.AddCancel1}
                      ></i>
                    </td>
                    <td className="" width="95%">
                    </td>
                  </tr>
                </tbody>
              </table>
            </>
          )}
          <div className="row" style={{ margin: this.state.isMobile ? "" : "5px" }}>
            <div className="row px-3">
              <div className="col-12 pt-2">
                {this.state.isMobile ? <></> : <h6>Ship Specific Condition - Container</h6>}
              </div>
            </div>
            <div className={this.state.isMobile ? "col-12 px-4 pt-2 mt-1" : "col-12 px-3 pt-2 mt-1"}>
              <div className="table-responsive" style={{ width: "100%" }}>
                <table id="Docstable" className="table table-borderless border-top border-bottom border-left border-right">
                  <thead>
                    <tr className="border-top section-color spandoc-thead">
                      <th className="border-right border-left" colSpan="12"><span className="spandoc-thead">Cargo Condition</span></th>
                    </tr>
                    <tr className="border-top section-color spandoc-thead">
                      <th className="border-right border-left" colSpan="12"><span className="spandoc-thead">Hatch Dimensions (L x B)</span></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.Hatch && this.state.Hatch?.Questions?.map((i, ind) => (
                      <>
                        <tr className="border-top design" onMouseEnter={() => this.setState({ HoverId: i.Id })} onMouseLeave={() => this.setState({ HoverId: 0 })}>

                          <td className={`${window.innerWidth < 1080 ? "docwidthmobile-td1" : "docwidth-td1"} border-right align-middle`}>
                            <span className="spandoc-td">{i.QuestionDescription}</span>
                          </td>
                          <td className="commentsrequire-td align-middle">
                            <span className="spandoc-td">
                              <CssTextField
                                multiline
                                fullWidth
                                variant="outlined"
                                type="text"
                                onChange={(e) => this.handleInputChange(e, i)}
                                onBlur={(e) => this.updatemastercomments(e, i)}
                                value={i.Answer && i.Answer}
                                InputProps={{
                                  className: `border-radius padding-space ${classes.inputfieldAlign}`,
                                }}
                              />
                            </span>
                          </td>
                          <td width="4%" className="text-center align-middle">{i.QuestionId===this.state.successId && this.state.isSuccess===true?
                            <span className="spandoc-success-img"><img src={successIcon} className="success-error-img"/></span>:null}
                            {i.QuestionId===this.state.successId && this.state.isFailure===true?<span className="spandoc-error-img">
                              <img src={errorIcon} className="success-error-img" /></span>:null} </td>
                        </tr>
                      </>))}
                      <tr className="border-right border-top text-center align-middle">
                        <td colSpan={3}>
                      <label className={this.state.isMobile ? "d-flex pt-2 m-0 mb-1 spandoc-thead" : "mb-1 spandoc-thead form-group m-0 float-start text-left"}>Comments&nbsp;:</label>
                     <TextField multiline minRows={5} variant="outlined" size="small" fullWidth
                        InputProps={{className: `border-radius mt-1 ${classes.inputfieldAlign}`, 
                        style: { fontSize: 12 }}}
                        value={this.state.HatchComments}
                        type="text"
                        onChange={(e) => this.handleInputCommentChange(e, "Hatch")}
                        onBlur={(e) => this.updateOperationalComments(e, "Hatch")}/>
                     </td>
                     <td width="4%" className="border-right text-center align-middle">{"Hatch" === this.state.CommentId && this.state.isSuccessComment === true ?
                        <span className="spandoc-success-img"><img src={successIcon} className="success-error-img" /></span> : null}
                        {"Hatch" === this.state.CommentId && this.state.isFailureComment === true ? <span className="spandoc-error-img">
                          <img src={errorIcon} className="success-error-img" /></span> : null} </td>
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              className={
                this.state.isMobile
                  ? "col-12 px-4 pt-2 mt-1 mx-1"
                  : "col-12 px-3 pt-2 mt-1 mx-1"
              }
            >
              <div className="table-responsive" style={{ width: "100%" }}>
                <table
                  id="Docstable"
                  className="table table-borderless border-top border-bottom border-left border-right"
                >
                  <thead>
                    <tr className="border-top section-color spandoc-thead">
                      <th className="border-right border-left">
                        <span className="spandoc-thead">Cargo Hold Capacities</span>
                      </th>
                      <th className="border-right border-left">
                        <span className="spandoc-thead"> M3</span>
                      </th>
                      <th className="border-right border-left">
                        <span className="spandoc-thead">TEU in holds</span>
                      </th>
                      <th className="border-right border-left">
                        <span className="spandoc-thead">TEU on deck</span>
                      </th>
                      <th className="border-left" colSpan="2">
                        <span className="spandoc-thead">Total TEU</span>
                      </th>
                    </tr>

                  </thead>
                  <tbody>
                    {this.state.CargoHold && this.state.CargoHold?.Questions?.map((j, ind) => (<>
                      <tr
                        className="border-top"
                        onMouseEnter={() => this.setState({ HoverId: j.Id })} onMouseLeave={() =>
                          this.setState({ HoverId: 0 })
                        }
                      >
                        <td
                          className={`${window.innerWidth < 1080
                            ? "docwidthmobile-td1"
                            : "docwidth-td1"
                            } border-right align-middle`}
                          width="50%"
                        >
                          <span className="spandoc-td">
                            {j.QuestionDescription}
                          </span>
                        </td>
                        {j.QuestionDescription !== "TOTAL" ? <>
                          <td className="commentsrequire-td2 align-middle border-right">
                            <div className="row">
                              <div className="col-12">
                                <span className="spandoc-td">
                                  <CssTextField
                                    multiline
                                    fullWidth
                                    variant="outlined"
                                    type="number"
                                    onChange={(e) => this.handleInputChange1(e, j, j?.AnswersList[0]?.CategoryId, j?.AnswersList[0]?.CategoryName)}
                                    onBlur={(e) => this.updatemastercomments1(e, j, j?.AnswersList[0]?.CategoryId, j?.AnswersList1?.filter((k) => k.CategoryName === "M^3")[0]?.AnswerLookupList[0]?.Id)}
                                    value={j?.AnswersList1 != null && j?.AnswersList1?.filter((k) => k.CategoryName === "M^3")[0]?.AnswerLookupList[0]?.Answer ? j?.AnswersList1?.filter((k) => k.CategoryName === "M^3")[0]?.AnswerLookupList[0]?.Answer : ""}
                                    InputProps={{
                                      className: `border-radius padding-space ${classes.inputfieldAlign}`,
                                    }}
                                  />
                                </span>
                              </div>
                              {/* <div className="col-4 pt-2">
                                <span className="spandoc-td">TEU</span>
                              </div> */}
                            </div>
                          </td>
                          <td className="commentsrequire-td2 align-middle border-right">
                            <div className="row">
                              <div className="col-12">
                                <span className="spandoc-td">
                                  <CssTextField
                                    multiline
                                    fullWidth
                                    variant="outlined"
                                    type="number"
                                    onChange={(e) => this.handleInputChange1(e, j, j?.AnswersList[1]?.CategoryId, j?.AnswersList[1]?.CategoryName)}
                                    onBlur={(e) => this.updatemastercomments1(e, j, j?.AnswersList[1]?.CategoryId, j?.AnswersList1?.filter((k) => k.CategoryName === "TEU in holds")[0]?.AnswerLookupList[0]?.Id)}
                                    value={j?.AnswersList1 != null && j?.AnswersList1?.filter((k) => k.CategoryName === "TEU in holds")[0]?.AnswerLookupList[0]?.Answer ? j?.AnswersList1?.filter((k) => k.CategoryName === "TEU in holds")[0]?.AnswerLookupList[0]?.Answer : ""}
                                    InputProps={{
                                      className: `border-radius padding-space text-right${classes.inputfieldAlign}`,
                                    }}
                                  />
                                </span>
                              </div>
                              {/* <div className="col-4 pt-2">
                                <span className="spandoc-td">TEU</span>
                              </div> */}
                            </div>
                          </td>
                          <td className="commentsrequire-td2 align-middle border-right">
                            <div className="row">
                              <div className="col-12">
                                <span className="spandoc-td">
                                  <CssTextField
                                    multiline
                                    fullWidth
                                    variant="outlined"
                                    type="number"
                                    onChange={(e) => this.handleInputChange1(e, j, j?.AnswersList[2]?.CategoryId, j?.AnswersList[2]?.CategoryName)}
                                    onBlur={(e) => this.updatemastercomments1(e, j, j?.AnswersList[2]?.CategoryId, j?.AnswersList1?.filter((k) => k.CategoryName === "TEU on deck")[0]?.AnswerLookupList[0]?.Id)}
                                    value={j?.AnswersList1 != null && j?.AnswersList1?.filter((k) => k.CategoryName === "TEU on deck")[0]?.AnswerLookupList[0]?.Answer ? j?.AnswersList1?.filter((k) => k.CategoryName === "TEU on deck")[0]?.AnswerLookupList[0]?.Answer : ""}
                                    InputProps={{
                                      className: `border-radius padding-space text-right ${classes.inputfieldAlign}`,
                                    }}
                                  />
                                </span>
                              </div>
                              {/* <div className="col-4 pt-2">
                                <span className="spandoc-td">TEU</span>
                              </div> */}
                            </div>
                          </td>
                          <td className="commentsrequire-td2 align-middle">
                            <div className="row">
                              <div className="col-12">
                                <span className="spandoc-td" id={`totalteu${ind}`}>
                                </span>
                              </div>
                              {/* <div className="col-4">
                                <span className="spandoc-td">TEU</span>
                              </div> */}
                            </div>
                          </td>
                        </> : <>
                          <td className=" commentsrequire-td2 align-middle border-right">
                            <div className="row">
                              <div className="col-12">
                                <span className="spandoc-td">
                                  {this.state.total1 && this.state.total1} M^3
                                </span>
                              </div>
                              {/* <div className="col-4">
                                <span className="spandoc-td">M^3</span>
                              </div> */}
                            </div>
                          </td>
                          <td className=" commentsrequire-td2 align-middle border-right">
                            <div className="row">
                              <div className="col-12">
                                <span className="spandoc-td">
                                  {this.state.total2 && this.state.total2} TEU
                                </span>
                              </div>
                              {/* <div className="col-4">
                                <span className="spandoc-td">TEU</span>
                              </div> */}
                            </div>
                          </td>
                          <td className=" commentsrequire-td2 align-middle border-right">
                            <div className="row">
                              <div className="col-8">
                                <span className="spandoc-td">
                                  {this.state.total3 && this.state.total3} TEU
                                </span>
                              </div>
                              {/* <div className="col-4">
                                <span className="spandoc-td">TEU</span>
                              </div> */}
                            </div>
                          </td>
                          <td className=" commentsrequire-td2 align-middle">
                            <div className="row">
                              <div className="col-8">
                                <span className="spandoc-td">
                                  {this.state.total4 && this.state.total4} TEU
                                </span>
                              </div>
                              {/* <div className="col-4">
                                <span className="spandoc-td">TEU</span>
                              </div> */}
                            </div>
                          </td>
                        </>}
                        <td width="4%" className="border-right text-center align-middle">{j.QuestionId===this.state.successId && this.state.isSuccess===true?
                            <span className="spandoc-success-img"><img src={successIcon} className="success-error-img"/></span>:null}
                            {j.QuestionId===this.state.successId && this.state.isFailure===true?<span className="spandoc-error-img">
                              <img src={errorIcon} className="success-error-img" /></span>:null} </td>
                      </tr>
                    </>))}
                    <tr className="border-right border-top text-center align-middle">
                        <td colSpan={5}>
                      <label className={this.state.isMobile ? "d-flex pt-2 m-0 mb-1 spandoc-thead" : "mb-1 spandoc-thead form-group m-0 float-start text-left"}>Comments&nbsp;:</label>
                     <TextField multiline minRows={5} variant="outlined" size="small" fullWidth
                        InputProps={{className: `border-radius mt-1 ${classes.inputfieldAlign}`, 
                        style: { fontSize: 12 }}}
                        value={this.state.CargoHoldComments}
                        type="text"
                        onChange={(e) => this.handleInputCommentChange(e, "CargoHold")}
                        onBlur={(e) => this.updateOperationalComments(e, "CargoHold")}/>
                     </td>
                     <td width="4%" className="border-right text-center align-middle">{"CargoHold" === this.state.CommentId && this.state.isSuccessComment === true ?
                        <span className="spandoc-success-img"><img src={successIcon} className="success-error-img" /></span> : null}
                        {"CargoHold" === this.state.CommentId && this.state.isFailureComment === true ? <span className="spandoc-error-img">
                          <img src={errorIcon} className="success-error-img" /></span> : null} </td>
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              className={
                this.state.isMobile
                  ? "col-12 px-4 pt-2 mt-1 mx-1"
                  : "col-12 px-3 pt-2 mt-1 mx-1"
              }
            >
              <div className="table-responsive" style={{ width: "100%" }}>
                <table
                  id="Docstable"
                  className="table table-borderless border-top border-bottom border-left border-right"
                >
                  <thead>
                    <tr className="border-top section-color spandoc-thead">
                      <th className="border-right border-left" colSpan="12"><span className="spandoc-thead">Reefer Capacity</span></th>
                    </tr>

                  </thead>
                  <tbody>
                    {this.state.ReeferCapacity && this.state.ReeferCapacity?.Questions?.map((i, ind) => (
                      <>
                        <tr className="border-top design" onMouseEnter={() => this.setState({ HoverId: i.Id })} onMouseLeave={() => this.setState({ HoverId: 0 })}>
                          <td className={`${window.innerWidth < 1080 ? "docwidthmobile-td1" : "docwidth-td1"} border-right align-middle`}>
                            <span className="spandoc-td">{i.QuestionDescription}</span>
                          </td>
                          {i.QuestionDescription == "TOTAL" ? <>
                            <td className="commentsrequire-td align-middle">
                              <span className="spandoc-td ml-2">
                                 {this.state.total5}
                              </span>
                            </td>
                          </> :
                            <td className="commentsrequire-td align-middle">
                              <span className="spandoc-td">
                                <CssTextField
                                  multiline
                                  fullWidth
                                  variant="outlined"
                                  type="text"
                                  onChange={(e) => this.handleInputChange2(e, i)}
                                  onBlur={(e) => this.updatemastercomments(e, i)}
                                  value={i.Answer && i.Answer}
                                  InputProps={{
                                    className: `border-radius padding-space ${classes.inputfieldAlign}`,
                                  }}
                                />
                              </span>
                            </td>}
                            <td width="4%" className="text-center align-middle">{i.QuestionId===this.state.successId && this.state.isSuccess===true?
                            <span className="spandoc-success-img"><img src={successIcon} className="success-error-img"/></span>:null}
                            {i.QuestionId===this.state.successId && this.state.isFailure===true?<span className="spandoc-error-img">
                              <img src={errorIcon} className="success-error-img" /></span>:null} </td>
                        </tr>
                      </>))}
                      <tr className="border-right border-top text-center align-middle">
                        <td colSpan={3}>
                      <label className={this.state.isMobile ? "d-flex pt-2 m-0 mb-1 spandoc-thead" : "mb-1 spandoc-thead form-group m-0 float-start text-left"}>Comments&nbsp;:</label>
                     <TextField multiline minRows={5} variant="outlined" size="small" fullWidth
                        InputProps={{className: `border-radius mt-1 ${classes.inputfieldAlign}`, 
                        style: { fontSize: 12 }}}
                        value={this.state.ReeferCapacityComments}
                        type="text"
                        onChange={(e) => this.handleInputCommentChange(e, "ReeferCapacity")}
                        onBlur={(e) => this.updateOperationalComments(e, "ReeferCapacity")}/>
                     </td>
                     <td width="4%" className="border-right text-center align-middle">{"ReeferCapacity" === this.state.CommentId && this.state.isSuccessComment === true ?
                        <span className="spandoc-success-img"><img src={successIcon} className="success-error-img" /></span> : null}
                        {"ReeferCapacity" === this.state.CommentId && this.state.isFailureComment === true ? <span className="spandoc-error-img">
                          <img src={errorIcon} className="success-error-img" /></span> : null} </td>
                      </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>

      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
    settings: state.commonReducer.settings || [],
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddEditCondition))
);
